function CookiePolicy(){
	this.cookieWrapper = null;

	this.hideCookieMessage = this.hideCookieMessage.bind(this);
}

CookiePolicy.prototype.showCookieMessage = function(message, moreInfoUrl, closeButtonText){
	this.cookieWrapper = document.createElement('div');
	this.cookieWrapper.setAttribute('class', 'cookie-policy-wrapper');
	
	const cookieContainer = document.createElement('div');
	cookieContainer.setAttribute('class', 'cookie-policy-container');

	const cookieContent = document.createElement('div');
	cookieContent.setAttribute('class', 'cookie-policy-content');

	const matches = message.match(/\[(.+)\]/);

	if(matches[1]){
		message = message.replace(matches[0], '<a href="' + moreInfoUrl + '">' + matches[1] + '</a>');
	}

	cookieContent.innerHTML = message;

	if(closeButtonText){
		const closeButton = document.createElement('button');
		closeButton.setAttribute('class', 'button cookie-policy-button');
		closeButton.appendChild(document.createTextNode(closeButtonText));
		cookieContent.appendChild(closeButton);
		closeButton.addEventListener('click', this.hideCookieMessage);
	}

	cookieContainer.appendChild(cookieContent);
	this.cookieWrapper.appendChild(cookieContainer);
	document.body.appendChild(this.cookieWrapper);
	document.body.classList.add('class', 'is-active-cookie-policy-message');
};

CookiePolicy.prototype.hideCookieMessage = function(message, moreInfoUrl){
	document.body.classList.remove('is-active-cookie-policy-message');

	this.cookieWrapper.parentNode.removeChild(this.cookieWrapper);
};

CookiePolicy.prototype.createCookie = function(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		expires = "; expires="+date.toGMTString();
	}

	document.cookie = name+"="+value+expires+"; path=/";
};

CookiePolicy.prototype.readCookie = function(name){
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
};

CookiePolicy.prototype.eraseCookie = function(name) {
	createCookie(name,"",-1);
};

export default CookiePolicy;